import CirgsReportIcon from './CirgsReportIcon';

export default CirgsReportIcon;
